import { TimerObservable } from './TimerObservable';
export var timer = TimerObservable.create;
//# sourceMappingURL=timer.js.map